/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('wishlisted-products')) {
    class WishlistedProducts extends HTMLElement {
        constructor() {
            super();

            this.start()
            this.open = this.regenerate
        }
        start(){
            this.url = theme.routes.search_url + '?view=wishlist-handles&type=product&q=';
            // this.container = this.querySelector('.products');
            this.container = this;
            this.currentId = this.dataset.productHandle;
            // this.max = 2;
            this.products = '';
            window.wishlisted = []
            if (window.localStorage) {
                let recentIds = window.localStorage.getItem('wishlist-handles');
                if (recentIds && typeof (recentIds) !== undefined) {
                    window.wishlisted = JSON.parse(recentIds);
                }
            }
        }
        connectedCallback() {
            this.buildUrl();
        }
        buildUrl() {
            let i = 0;
            this.products = ""
            window.wishlisted.forEach((val) => {
                this.products += 'handle:' + val + ' OR ';
                i++;
            });

            this.url = this.url + encodeURIComponent(this.products);

            $(document).ready(this.fetchProducts())
        }
        regenerate(){
            this.start()
            this.connectedCallback()
        }
        fetchProducts() {
            // console.table([this.url, window.wishlisted])
            fetch(this.url)
            .then(response => response.text())
            .then(text => {
                const html = $(`<div>`);
                const textHtml = $(text);
                html.html(textHtml)
                const products = html.find('#product-grid')
                const recommendations = products;
                if (recommendations) {
                    $(this.container).html(recommendations);
                    this.classList.add('product-wishlisted--loaded');
                    scrollableContentCM(this)
                }
                if(recommendations.find(`product-card`).length < 1){
                    $('.no-wishlist-message').show()
                }else {
                    $('.no-wishlist-message').hide()
                }

                return;
                const generate = async (objectL) => {
                    const obj = {}
                    obj.variants = {list: false}
                    try {
                        obj.variants = JSON.parse(objectL?.variants ?? `{}`)
                    } catch (error) {
                    }
                    try {
                        obj.images = JSON.parse(objectL?.images ?? `{}`)
                    } catch (error) {
                    }
        
                    if(!obj?.variants?.list){
                        const {id, enabled} = {...objectL}
                        if(id && enabled && (enabled == "ring" || enabled == "necklace")){
                            try {
                                let response = await fetch(`https://personaly-meinekette-custom.de/api/${enabled}-proudct/${id}`)
                                response = await response.json()
                                obj.variants.list = response?.customizer?.options?.list
                                obj.images = response?.customizer?.images
                            } catch (error) {
                            }
                        }
                    }
        
                    const options_list = obj?.variants?.list
                    const variantItemsAll = {}
                    const names_filter_types = {}
                    const stone_names = {}
        
                    const recursive_check = (list) => {
                        list?.length > 0 && list?.map(item => {
                            if(item?.filter_type){
                                names_filter_types[item?.name] = item?.filter_type
                            }
                            if(item?.is_stone && item?.name){
                                stone_names[item?.name] = true
                            }
                            if(item?.type == "engraving") {
                                return
                            }
                            if(item?.list?.length > 0 || item?.has_sub_item){
                                recursive_check(item?.list)
                            }else if(item?.is_variant){
                                if(!variantItemsAll[item?.name]){
                                    variantItemsAll[item?.name] = []
                                }
                                variantItemsAll[item?.name].push(item)
                            }
                        })
                    }
                    recursive_check(options_list)
                    let seenCombinations = new Set();
        
                    const generateVariants = (options) => {
                        const optionKeys = Object.keys(options);
                        if (optionKeys.length === 0) return [];
                        const combineOptions = (keys, currentIndex, currentCombination) => {
                            if (currentIndex === keys.length) {
                                return [currentCombination];
                            }
                    
                            const currentKey = keys[currentIndex];
                            const currentOptions = options[currentKey] || [];
                            const combinations = [];
                    
                            currentOptions.forEach((option) => {
                                const newCombination = { ...currentCombination };
                                newCombination[currentKey] = option;
                                combinations.push(
                                    ...combineOptions(keys, currentIndex + 1, newCombination)
                                );
                            });
                    
                            return combinations;
                        };
                    
                        const allCombinations = combineOptions(optionKeys, 0, {});
                    
                        const formattedVariants = allCombinations.map((combination) => {
                            let labels = [];
                            let ids = [];
                            let price = 0;
                            let compare_at_price = 0;
                    
                            let is_all_has_img = true;
                            let img_list_labels = [];
                            let img_list_ids = [];
                            let first_id = false;
        
                            const filter_values = {}
                            let metalLabel = ""
                            let colorLabel = ""
                    
                            Object.keys(combination).forEach((key, idx) => {
                                const option = combination[key];
                                const label = `${option.value ?? option?.label}`;
                                ids.push(option?.id);
                                if(names_filter_types[key] == "metal"){
                                    metalLabel = label
                                }else if(stone_names[key]){
                                    labels.push(label);
                                }
                                // if(names_filter_types[key] == "color"){
                                //     colorLabel = label
                                // }
                                filter_values[names_filter_types[key]] = option.value ?? option?.label
                    
                                if (option?.has_image) {
                                    img_list_labels.push(label);
                                    img_list_ids.push(option?.id);
                                }
                    
                                if (idx === 0) {
                                    first_id = option;
                                }
                    
                                if (is_all_has_img && !option?.has_image) {
                                    is_all_has_img = false;
                                }
                    
                                const pp = parseFloat(option?.price || 0);
                                const cp_pp = parseFloat(option?.compare_at_price || 0);
                                price += pp;
                                compare_at_price += Math.max(cp_pp, pp);
                            });
                    
                            const variantId = ids.join("-"); 
                    
                            if (seenCombinations.has(variantId)) {
                                return null; 
                            }
                            
                            const labelsList = [...(metalLabel ? [metalLabel] : []), ...labels]
                            const v_item = {
                                label: labelsList.join(" & "),
                                id: variantId,
                                price: price,
                                has_metal: metalLabel,
                                filter: filter_values,
                                image_ids: img_list_ids,
                                options: ids,
                                compare_at_price: compare_at_price,
                            };
                            seenCombinations.add(variantId);
                            return v_item;
                        }).filter(Boolean); 
        
                        return formattedVariants
                    };
        
                    const dynamicVariants = generateVariants(variantItemsAll);
        
                    const filterd = {};
                    const urlParams = new URLSearchParams(window.location.search);
                    urlParams.forEach((value, name) => {
                        if(name?.startsWith("filter.")){
                            const name_r = name?.replace("filter.p.m.filter.filter_variants_", "")
                            filterd[name_r] = value
                        }
                    });
                    // container.querySelectorAll(`collapsible-row input[name][checked]`).forEach((item) => {
                    //     const name = item?.getAttribute("name")
                    //     if(name.includes("filter_variants")){
                    //         const name_r = name?.replace("filter.p.m.filter.filter_variants_", "")
                    //         filterd[name_r] = item.value
                    //     }
                    // })
        
                    var filtered_variants = []
                    let min_price = dynamicVariants?.[0]?.price ?? 0;
                    let max_price = dynamicVariants?.[0]?.price ?? 0;
                    if(Object.keys(filterd).length > 0){
                        dynamicVariants.forEach((item) => {
                            const filter_values = item?.filter ?? {}
                            min_price = Math.min(min_price, (item?.price ?? 0))
                            max_price = Math.max(max_price, (item?.price ?? 0))
                            var isOkay = true
                            Object.keys(filterd).forEach((filter_idx) => {
                                if(filter_values[filter_idx] != filterd[filter_idx]){
                                    isOkay = false;
                                    return;
                                }
                            })
                            if(isOkay){
                                filtered_variants.push(item)
                            }
                        }) 
                    }else {
                        filtered_variants = dynamicVariants
                    }
        
                    filtered_variants.sort((a, b) => a.price - b.price);
        
        
                    const variant_item = filtered_variants[0]
        
                    // if(!variant_item?.has_metal && variant_item){
                    let metalValueV = ""
                    if(variant_item){
                        let metalIndex = false
                        objectL?.s_options?.some((item, idx) => {
                            const lowerName = item?.toLowerCase()
                            if(lowerName == "metal" || lowerName == "material"){
                                metalIndex = idx;
                                return;
                            }
                        });
                        if(metalIndex > -1){
                            const metalVal = objectL?.s_variant?.options?.[metalIndex]
                            metalValueV = metalVal;
                            const metalValue = [...(metalVal ? [metalVal] : []), ...(variant_item?.label ? [variant_item?.label] : [])]
                            variant_item.label = metalValue.join(" & ")
                            variant_item.metalVal = metalValueV
                        }
                    }else {
                        // const p_options = objectL?.s_options ?? []
                        // const metalIdx = false;
                        // p_options?.forEach((item, i) => {
                        //     p_options[i] = item?.toLowerCase()
                        // })
                        // p_options?.some((item, idx) => {
                        //     const lowerName = item?.toLowerCase()
                        //     if(lowerName == "metal" || lowerName == "material"){
                        //         metalIdx = idx + 1;
                        //         return;
                        //     }
                        // })
                        // let valuesIdx = [];
                        // filterd?.forEach((item) => {
        
                        // })
                    }
                    
                    let images = []
                    const variant_id = variant_item?.image_ids
                    if(obj?.images){
                        const keys = Object.keys(obj?.images)
                        for(let i = 0; i < keys.length; i++){
                            const key = keys[i]
                            let isokay = variant_id?.length > 0;
                            for(let j = 0; j < variant_id?.length; j++){
                                if(!key?.includes(variant_id[j])){
                                    isokay = false
                                    break;
                                }
                            }
                            if(isokay){
                                images = obj?.images?.[keys[i]]
                                break
                            }
                        }
                    }
                    
                    return [variant_item, images, filterd, min_price, max_price];
        
                    // return filtered_variants;
                }
        
                Object.keys(products_infos_variants_images).forEach( async (handle) => {
                    const productCard = html.find(`product-card[data-handle="${handle}"]`)
                    if(productCard){
                        let [variant, images, filterd, min_price, max_price] = await generate(products_infos_variants_images[handle])
                        let title = variant?.label;
        
        
                        let price = parseInt((variant?.price ?? 0)) * 100;
                        const p_variants = products_infos_variants_images[handle]?.p_variants ?? []
        
                        let min_v_price = p_variants?.[0]?.price
                        let max_v_price = min_v_price
                        p_variants?.forEach((item) => {
                            min_v_price = Math.min(item?.price, min_v_price)
                            max_v_price = Math.max(item?.price, max_v_price)
                        })
                        productCard.find(".min-max-price-range").text(`${shopifyFormatCurrency(min_v_price)} - ${shopifyFormatCurrency(((max_price ?? 0) * 100) + max_v_price)}`)
        
                        const s_options = products_infos_variants_images[handle]?.s_options ?? []
                        let found_variant = p_variants?.[0]
                        if(variant?.metalVal){
                            if(!filterd["filter.v.option.material"] && s_options?.indexOf("Material") > -1){
                                filterd["filter.v.option.material"] = variant.metalVal
                            }
                        }
                        if(Object.keys(filterd).length > 0){
                            const values = {}
                            Object.keys(filterd).map((f_name) => {
                                s_options?.map((item, idx) => {
                                    if(item.toLowerCase() == f_name?.toLowerCase()?.replace("filter.v.option.", "")){
                                        values[idx+1] = filterd[f_name]
                                    }
                                })
                            })
                            const v_keys = Object.keys(values)
                            if(v_keys.length > 0){
                                for(let i = 0; i < p_variants?.length; i++){
                                    let isOkay = true;
                                    for(let j = 0; j < v_keys.length; j++){
                                        if(p_variants[i]?.["option"+v_keys[j]] != values[v_keys[j]]){
                                            isOkay = false
                                            break;
                                        }
                                    }
                                    if(isOkay){
                                        found_variant = p_variants[i]
                                        break
                                    }
                                }
                            }
                        }
                        const m_price = shopifyFormatCurrency(parseInt(price + (found_variant?.price ?? 0)))
                        const c_price = shopifyFormatCurrency(parseInt(price + (found_variant?.compare_at_price ?? 0)))
                        // price = shopifyFormatCurrency(parseInt(m_price))
                        productCard.find(".price .amount:not(.compare-at-price)").text(m_price)
                        productCard.find(".price .amount.compare-at-price").text(c_price)
        
                        let metalIdx = false;
                        if(!title){
                            const p_options = s_options ?? []
                            p_options?.forEach((item, i) => {
                                p_options[i] = item?.toLowerCase()
                            })
                            p_options?.some((item, idx) => {
                                const lowerName = item?.toLowerCase()
                                if(lowerName == "metal" || lowerName == "material"){
                                    metalIdx = idx + 1;
                                    return;
                                }
                            })
                            title = found_variant?.["option"+metalIdx];
                        }
                        productCard.find(".product-card-sub-title").text(title)
        
                        if(images?.length < 1){
                            const p_media = products_infos_variants_images[handle]?.p_media ?? []
                            const urlParams = new URLSearchParams(window.location.search);
                            let activeColorVal = ""
                            urlParams.forEach((value, name) => {
                                if(name?.startsWith("filter.")){
                                    const nameL = name?.replace("filter.v.option.", "")
                                    if(nameL?.includes("color") || nameL?.includes("colour") || nameL?.includes("couleur") || nameL?.includes("farbe")){
                                        activeColorVal = value
                                    }
                                }
                            });
                            let colorOptionIndex = false;
                            s_options?.forEach((item, idx) => {
                                const nameL = item?.toLowerCase()
                                if(nameL?.includes("color") || nameL?.includes("colour") || nameL?.includes("couleur") || nameL?.includes("farbe")){
                                    colorOptionIndex = idx+1;
                                    return;
                                }
                            })
                            if(!activeColorVal){
                                activeColorVal = found_variant?.['option'+colorOptionIndex]
                            }
                            // const mediaIndex = found_variant?.featured_image?.id
                            if(activeColorVal){
        
                                const newImages = []
                                let featured_media_id = null
                                let featured_medias = {}
        
                                p_variants?.forEach((item, idx) => {
                                    featured_medias[item?.featured_media?.id] = true
                                    if(item?.["option"+colorOptionIndex] == activeColorVal){
                                        featured_media_id = item?.featured_media?.id
                                    }
                                })
                                let start = false
                                for(let i = 0; i < p_media?.length; i++){
                                    const item = p_media[i]
                                    if(item?.id == featured_media_id && !start){
                                        start = true
                                    }
                                    if(start){
                                        if(!featured_medias[item?.id] || item?.id == featured_media_id){
                                            newImages.push(item?.preview_image?.src)
                                        }else {
                                            if(featured_media_id != item?.id){
                                                break;
                                            }
                                        }
                                    }
                                }
                                // console.log(newImages)
                                images = newImages
                            }
                        }
        
        
                        let imgELS = $("<div>")
                        if(images?.length > 0){
                            for(let i = 0; i < images.length; i++){
                                imgELS.append(`<img class="no-blur product-primary-image image-view-${i} ${i == 0 ? "active" : ""} product-image-view" width="2000" height="2000" data-sizes="auto" src="${images[i]}" data-srcset="${images[i]}" sizes="313px" srcset="${images[i]}">`)
                            }
                            productCard.find(".slider__img").html(imgELS.html())
                        }
        
                        const currentHref = productCard.find("a[href]").first().attr("href");
                        const url = new URL(currentHref, window.location.origin); 
                        Object.keys((filterd ?? {})).forEach(key => {
                            url.searchParams.set("c_value__"+key, filterd[key]);
                        })
                        productCard.find("a[href]").attr("href", url.href);
                        window.generateProductCardSlider(productCard.find(".thb_slider_list"))
                            
                    }
                })

            })
            .catch(e => {
                console.error(e);
            });
        }
    }

    customElements.define('wishlisted-products', WishlistedProducts);
}